<template>
  <v-toolbar color="blue darken-1" fixed dark app style="z-index:2">
    <v-toolbar-title class="ml-0 pl-3" style="margin-left:-20px!important">
      <v-toolbar-side-icon
        v-show="getShowToggleButton"
        @click.stop="handleDrawerToggle('APP_LEFT_DRAWER_TOGGLE')"
      ></v-toolbar-side-icon>
      <v-tooltip bottom v-show="getShowReturnButton">
        <v-btn slot="activator" icon @click="returnClick()">
          <v-icon>reply</v-icon>
        </v-btn>
        <span>{{$t('return')}}</span>
      </v-tooltip>
      <span id="pagetitleshow">{{ $t(getPageTitle)}}</span>
    </v-toolbar-title>
    <v-spacer/>

    <v-tooltip bottom v-show="getShowFilterButton">
      <v-btn slot="activator" icon @click.stop="handleDrawerToggle('APP_RIGHT_DRAWER_TOGGLE')">
        <v-icon :size="16">fa-filter</v-icon>
      </v-btn>
      <span>{{$t('filter')}}</span>
    </v-tooltip>
  </v-toolbar>
</template>
<script>
/* eslint-disable */
import { mapGetters, mapActions } from "vuex";

export default {
  data: () => ({
    isSearchClose: true,
    showFilter: true
  }),
  computed: {
    ...mapGetters("app", [
      "getPageTitle",
      "getShowPageTitle",
      "getShowSearchBox",
      "getShowToggleButton",
      "getShowFilterButton",
      "getShowReturnButton",
    ])
  },
  methods: {
    handleDrawerToggle(drawer_name) {
      window.getApp.$emit(drawer_name);
      this.$emit("set");
    },
    returnClick() {
      if (this.getParentRoute) {
        let parentRoute = this.getParentRoute;
        this.setParentRoute("");
        this.$router.push(parentRoute);
      } else if (this.$router.options.routes.length > 0) {
        this.$router.replace("/dashboard");
        //this.$router.go(-1);
      } else {
        this.$router.replace("/dashboard");
      }
    },
    searchClick() {
      if (this.isSearchClose) {
        this.isSearchClose = false;
      } else {
        this.isSearchClose = true;
      }
    }
  }
};
</script>
